import SelectActiveADGroup from './SelectActiveADGroup.container';

export default SelectActiveADGroup;
